import { AxiosInstance } from 'axios'

import { BalanceAI } from '@modules/ai/types/BalancesAI/balances'

export class AiBalancesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async getBalance(): Promise<BalanceAI> {
    const response = await this.instance.get(`/ai/balances/balance`)

    return response.data
  }
}

export const aiBalancesService = (instance: AxiosInstance) => new AiBalancesService(instance)
